module.exports = __webpack_public_path__ + "img/iconShenHeJiaYouShenQing.243108c9.svg";